// Ecuador cities with approximate coordinates (lat, lng)
export const ECUADOR_CITIES = [
  { name: "Quito", lat: -0.1807, lng: -78.4678 },
  { name: "Guayaquil", lat: -2.1709, lng: -79.9224 },
  { name: "Cuenca", lat: -2.9006, lng: -79.0045 },
  { name: "Santo Domingo", lat: -0.2521, lng: -79.1751 },
  { name: "Machala", lat: -3.2581, lng: -79.9553 },
  { name: "Durán", lat: -2.1739, lng: -79.8340 },
  { name: "Manta", lat: -0.9677, lng: -80.7089 },
  { name: "Portoviejo", lat: -1.0546, lng: -80.4525 },
  { name: "Loja", lat: -3.9931, lng: -79.2042 },
  { name: "Ambato", lat: -1.2544, lng: -78.6267 },
  { name: "Esmeraldas", lat: 0.9682, lng: -79.6517 },
  { name: "Quevedo", lat: -1.0225, lng: -79.4606 },
  { name: "Riobamba", lat: -1.6635, lng: -78.6547 },
  { name: "Milagro", lat: -2.1339, lng: -79.5872 },
  { name: "Ibarra", lat: 0.3495, lng: -78.1226 },
  { name: "La Libertad", lat: -2.2333, lng: -80.9106 },
  { name: "Latacunga", lat: -0.9314, lng: -78.6156 },
  { name: "Babahoyo", lat: -1.8018, lng: -79.5342 },
  { name: "Sangolquí", lat: -0.3170, lng: -78.4498 },
  { name: "Daule", lat: -1.8620, lng: -79.9770 },
  { name: "Tulcán", lat: 0.8121, lng: -77.7181 },
  { name: "Azogues", lat: -2.7386, lng: -78.8483 },
  { name: "Guaranda", lat: -1.5905, lng: -79.0027 },
  { name: "Nueva Loja", lat: 0.0872, lng: -76.8836 },
  { name: "Tena", lat: -0.9927, lng: -77.8144 },
  { name: "Puyo", lat: -1.4833, lng: -77.9833 },
  { name: "Macas", lat: -2.3049, lng: -78.1188 },
  { name: "Zamora", lat: -4.0679, lng: -78.9564 },
  { name: "Santa Rosa", lat: -3.4536, lng: -79.9611 },
  { name: "Huaquillas", lat: -3.4767, lng: -80.2287 },
];

export const CITY_NAMES = ECUADOR_CITIES.map(c => c.name);

// Haversine distance in km
export function nearestCity(lat, lng) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  let best = null, bestD = Infinity;
  for (const c of ECUADOR_CITIES) {
    const dLat = toRad(c.lat - lat);
    const dLng = toRad(c.lng - lng);
    const a = Math.sin(dLat/2)**2 +
              Math.cos(toRad(lat)) * Math.cos(toRad(c.lat)) * Math.sin(dLng/2)**2;
    const d = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    if (d < bestD) { bestD = d; best = c; }
  }
  return { city: best, distance_km: bestD };
}
